/* istanbul ignore file */

// eslint-disable-next-line @typescript-eslint/typedef
export const ServicePaginationConfigLimits = [10, 20, 30, 50, 100] as const;

export type ServicePaginationConfigLimit = typeof ServicePaginationConfigLimits[number];

export interface ServicePaginationModel {
  page: number;
  count: number;
  limit: ServicePaginationConfigLimit;
  limits: ServicePaginationConfigLimit[];
}

export const ServicePaginationConfigDefaultPage: number = 1;
export const ServicePaginationConfigDefaultLimit: ServicePaginationConfigLimit = ServicePaginationConfigLimits[0];
